module.exports = __webpack_public_path__ + "static/aei-e34d27ec3879b4cc5b1b3ad951adcb03.png";